export default __webpack_public_path__ + "static/media/woman.84493ccc.svg";